<template>
  <!--删除费用-->
  <el-dialog
    :title="$t('receivablePayable.DeleteTheFee')"
    :visible.sync="showDeleteRow"
    width="500px"
  >
    <div>
      <!--注意：会删除所选费用类型的所有数据-->
      <div style="color: red;margin-bottom: 20px;">{{
        $t('receivablePayable.NoteAllDataSelectedChargeDeleted')
      }}
      </div>
      <div>
        <!--费用类型-->
        <span style="color: red">*</span>{{ $t('basicData.ExpenseType') }}：
        <el-select
          v-model="feeTypeName"
          :placeholder="$t('operationCenter.PleaseSelect')"
          clearable
          filterable
          size="small"
          style="width: 100%;"
        >
          <el-option
            v-for="item in feeList"
            :key="item.id"
            :label="item.displayName"
            :value="item.code"
          />
        </el-select>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!--取 消-->
      <el-button @click="close">{{ $t('basicData.Cancel') }}</el-button>
      <!--确 定-->
      <el-button type="primary" @click="saveDeleteRow">{{ $t('basicData.determine') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiSiteExpenseDeleteFeeSub } from '@/api/finance/receivables';

export default {
  name: 'DelFeeDialog',

  props: {
    // 费用列表
    feeList: {
      type: Array,
      default: () => []
    },
    // 选中行
    selectData: {
      type: Array,
      default: () => []
    },
    // 查询参数
    queryForm: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      showDeleteRow: false,
      feeTypeName: ''
    };
  },

  methods: {
    open() {
      this.showDeleteRow = true;
    },
    close() {
      this.showDeleteRow = false;
    },
    saveDeleteRow() {
      if (!this.feeTypeName) {
        this.$message.warning(this.$t('receivablePayable.TheChargeTypeCannotBeEmpty')); // '费用类型不能为空'
        return;
      }
      const ids = this.selectData.map(item => item.id);
      const param = {
        ...this.queryForm,
        ids
      };
      param.feeCode = this.feeTypeName;
      this.$confirm(this.$t('receivablePayable.ConfirmDeletionAllDataForSelectedExpenseType'), this.$t('basicData.tips'), { // '确认删除所选费用类型的所有数据？' 提示
        confirmButtonText: this.$t('basicData.determine'), // '确定',
        cancelButtonText: this.$t('basicData.Cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        apiSiteExpenseDeleteFeeSub(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.close();

            // 刷新列表
            this.$emit('change');
          }
        });
      }).catch(() => {
      });
    }
  }
};
</script>

<style scoped>

</style>
